import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from '@cognite/e2e-auth';

import { QueryKeys } from '../../../../utils/queryKeys';

export const useDatamodelVersion = (space: string) => {
  const { client } = useAuthContext();

  return useQuery({
    queryKey: [QueryKeys.DATAMODEL_VERSION, space],
    queryFn: async () => {
      return client.dataModels
        .list({ space, allVersions: true, includeGlobal: true })
        .then((models) =>
          models.items
            .filter((x) => x.externalId === space)
            .map((x) => x.version)
        );
    },
    meta: { error: { captureError: true, level: 'fatal' } },
    enabled: space !== '',
  });
};
